import { createAsyncThunk } from '@reduxjs/toolkit';

import { vitrinsQueries } from 'entities/vitrins/model/vitrins.query';
import type { TVitrinsFiltersState } from 'entities/vitrinsFilters';
import { selectActiveVitrinsFilters, toggleFilter } from 'entities/vitrinsFilters';

export const applyFilter = createAsyncThunk<void, { alias: string; value: string }, { state: TVitrinsFiltersState }>(
  'vitrinsFilters/apply',
  async ({ alias, value }, { dispatch, getState }) => {
    dispatch(toggleFilter({ alias, value }));

    const state = getState();

    const filtersMap = selectActiveVitrinsFilters(state);

    await dispatch(vitrinsQueries.endpoints.getVitrins.initiate(filtersMap, { forceRefetch: true }));
  },
);
